import React from 'react'
import { HashLink as Link } from 'react-router-hash-link'

const Button = (props) => {
    let renderButton = null
    const disabledClass = props.disabled ? 'cbutton--disabled' : ''

    const whiteButton = (
        <div className="cbutton cbutton--white">
            <span className="cbutton__text">{props.text}</span>
        </div>
    )

    const yellowButton = (
        <div className={`cbutton cbutton--yellow ${props.className}`} onClick={props.onClick}>
            <span className="cbutton__text">{props.text}</span>
        </div>
    )

    const arrowButton = (
        <div className="cbutton cbutton--yellow">
            <span className="cbutton__text cbutton__text--arrow">
                {props.text}
            </span>
            <span className="cbutton-arrow-container">
                <img
                    className="cbutton-arrow-container__img"
                    src="/images/ico/bed_arrowbutton.png"
                />
            </span>
        </div>
    )

    const footerButton = (
        <div className="cbutton cbutton--yellow cbutton--footer">
            <span className={'cbutton__text cbutton__text--footer '}>{props.text}</span>
        </div>
    )

    if (props.type === 'white') {
        renderButton = whiteButton
    } else if (props.type === 'yellow') {
        renderButton = yellowButton
    } else if (props.type === 'arrow') {
        renderButton = arrowButton
    } else if (props.type === 'footer') {
        renderButton = footerButton
    }

    if (props.onClick) {
        return (
            <div
                onClick={props.onClick}
                className={disabledClass}
            >
                {renderButton}
            </div>
        )
    }

    if (props.outsideLink) {
        return (
            <a href={props.outsideLink}>
                {renderButton}
            </a>
        )
    }

    return (
        <Link to={props.link}>
            {renderButton}
        </Link>
    )
}

Button.defaultProps = {
    type: '', // white, yellow, arrow, footer
    text: '',
    link: '',
    outsideLink: '',
    onClick: null,
    className: '',
    disabled: false
}

export default Button



// WEBPACK FOOTER //
// ./src/scripts/components/Button.jsx